export enum EmailStatus {
    DRAFT,
    SENT,
    PENDING,
    FAILED
}